import React from "react";
import styles from "../components/laymanComp_css/LaymanPage6.module.css";
import { Link } from "@mui/material";
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/yinYang.json";

export default function LaymanPage6() {
  return (
    <>
   <Common_html BlockData={BlockData} />
    </>
  );
}
